// extracted by mini-css-extract-plugin
export default {"blinkingCursor":"TypingText_blinkingCursor__6G3gW","blink":"TypingText_blink__XPhOF"};